import { Component, Input, inject } from '@angular/core';
import { AssemblyOrderModel } from 'src/app/models/assembly-order.model';
import { ManufacturingOrderStatusService } from 'src/app/services/manufacturing-order-status.service';
import { AssemblyOrderEnum } from 'src/app/shared/enumerators/assembly-order.enum';
import { PoolShellStatusEnum } from 'src/app/shared/enumerators/pool-shell-status.enum';
import { ProductStatusEnum } from 'src/app/shared/enumerators/product-status.enum';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

const STATUS_TOKENS: Record<string, string> = {
  OAPendiente: 'pending',
  OABloqueada: 'blocked',
  OAEnPreparacion: 'preparing',
  OAArmada: 'assembled',
  OAModificada: 'modified',
  OACancelada: 'cancelled',
  OAReprogramada: 'rescheduled',
  OAProgramada: 'scheduled',
  OAPospuesta: 'postponed',
};

@Component({
    selector: 'app-manufacturing-order',
    templateUrl: './manufacturing-order.component.html',
    styleUrls: ['./manufacturing-order.component.scss'],
    imports: [NgClass, MatIcon],
    // The board's "you came back from here" pulse (manufacturing-calendar) takes the status color from this variable.
    host: { '[style.--ao-status]': 'statusColor()' }
})
export class ManufacturingOrderComponent {
  private readonly moStatusService = inject(ManufacturingOrderStatusService);

  @Input() assemblyOrder!: AssemblyOrderModel;
  @Input() maxHeight?: number;
  @Input() showOrderDetails: boolean = false;

  _assemblyOrderEnum = AssemblyOrderEnum;

  getOrderStatus(status: AssemblyOrderEnum) {
    switch (status) {
      case AssemblyOrderEnum.Bloqueada:
        return 'OABloqueada';
      case AssemblyOrderEnum.EnPreparacion:
        return 'OAEnPreparacion';
      case AssemblyOrderEnum.Armada:
        return 'OAArmada';
      case AssemblyOrderEnum.Modificada:
        return 'OAModificada';
      case AssemblyOrderEnum.Cancelada:
        return 'OACancelada';
      case AssemblyOrderEnum.Reprogramada:
        return 'OAReprogramada';
      case AssemblyOrderEnum.Programado:
        return 'OAProgramada';
      case AssemblyOrderEnum.Pendiente:
        return 'OAPendiente';
      case AssemblyOrderEnum.Pospuesta:
        return 'OAPospuesta';
      default:
        return 'OAPendiente';
    }
  }

  /** Frame color of the order's status, the same token its .OA* class uses. */
  statusColor(): string {
    return `var(--tp-assembly-${STATUS_TOKENS[this.getOrderStatus(this.assemblyOrder?.statusId)]})`;
  }

  getDiagonalStrip(status: AssemblyOrderEnum) {
    switch (status) {
      case AssemblyOrderEnum.Cancelada:
        return 'diagonal-strip-OACancelada';
      case AssemblyOrderEnum.Reprogramada:
        return 'diagonal-strip-OAReprogramada';
      case AssemblyOrderEnum.Pospuesta:
        return 'diagonal-strip-OAPospuesta';
      default:
        return '';
    }
  }

  getProdStatus(statusId: ProductStatusEnum): string {
    return this.moStatusService.getProdStatus(statusId);
  }

  getPoolStatus(status: PoolShellStatusEnum): string {
    return this.moStatusService.getPoolStatus(status);
  }

  get isOrderFinished(): boolean {
    return (
      this.assemblyOrder.poolShell.statusId == PoolShellStatusEnum.Lista &&
      this.assemblyOrder.assemblyTasks.every(
        (x) => x.statusId == ProductStatusEnum.Lista
      )
    );
  }
}
